import { useState, useEffect, useRef } from "react";
import dayjs from 'dayjs';

import { Button, Form, Spin, Card, Tabs, Row, Col, Input, Select } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined } from '@ant-design/icons';

import "../style.css";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

import { IDirigenteExcepcional, IDirigenteExcepcionalPlanoBeneficio, IDocumentoDirigenteExcepcional } from "../Componentes/InterfaceDirigenteExcepcional";
import { IAuditoria, ICtrlDoc, IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";
import DirigenteExcepcionalPlano from "../Componentes/DirigenteExcepcionalPlano";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";

import { resetColor } from "../../../styles/cnpjColor";
import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../utils/messages";

import { maskCpf } from "../../../utils/maskFunctions";
import { IErroApi } from "../../../Interfaces/Interfaces";
import DirigenteExcepcionalPerfil from "../Componentes/DirigenteExcepcionalPerfil";
import { maskCnpj } from "../../../utils/maskFunctions";
import { isValidCNPJ } from 'cnpj-cpf-validator';
import { hasText, isAntesDoTermino, isStateValid, onlyNumbers } from "../../../utils/utilsFunctions";
import PessoaFisicaDadosPessoaisComplementares from "../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";
import DirigenteExcepcionalDocumento from "../Componentes/DirigenteExcepcionalDocumento";
import Auditoria from "../../../components/Auditoria";
import { useLocation } from "react-router";
import Watermark from "../../../components/WaterMark";
import InfoHistorico from "../../../components/InfoHistorico";
import { getPessoaJuridica, postPessoaJuridica } from "../../../services/apiCad";
import { apiCand } from "../../../services/apiCand";
import { obterFuncaoPorNumero, obterObjetoDirExcepPorNumero } from "../Componentes/EnumsParaDirigenteExcepcional";
import { apiAuxiliar } from "../../../services/apiAuxiliar";

const Manter = (props: any) => {
  const [form] = Form.useForm();

  const { state } = useLocation();

  const [isDirty, setIsDirty] = useState(false);
  const handlerRef = useRef<(e: BeforeUnloadEvent) => void>(null);

  const [matriculaEfpc, setMatriculaEfpc] = useState("");

  const [dadosDirigenteExcepcional, setDadosDirigenteExcepcional] = useState<IDirigenteExcepcional>();

  const [dadosAuditoria, setDadosAuditoria] = useState<IAuditoria[]>([]);
  const [registroHistorico, setRegistroHistorico] = useState<IAuditoria>();
  const [activeKey, setActiveKey] = useState('item-1');

  const [manter, setManter] = useState(2); // 2 : Detalhar / 3 : Alterar / 9 : Histórico
  const [erroApi, setErroApi] = useState<IErroApi>()
  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)
  const [csObjeto, setCsObjeto] = useState(0);
  const [servidorPublico, setServidorPublico] = useState(false);
  const [cnpjReceitaFederal, setCnpjReceitaFederal] = useState<string>()
  const [dirigenteExcepcionalPlanosBeneficio, setDirigenteExcepcionalPlanosBeneficio] = useState<IDirigenteExcepcionalPlanoBeneficio[]>([]);
  const [dirigenteExcepcionalDocumentos, setDirigenteExcepcionalDocumentos] = useState<IDocumentoDirigenteExcepcional[]>([]);

  const [ctrlDoc, setCtrlDoc] = useState<ICtrlDoc[]>([]);

  const [entidades, setEntidades] = useState<IEntidade[]>([]);


  useEffect(() => {
    window.scrollTo(0, 0)

    if (isStateValid(state)) {
      // console.log(state);

      setManter(state.manter)

      form.setFieldsValue({
        "nuCpf": maskCpf( state.data.pessoaFisica.nuCpf ? state.data.pessoaFisica.nuCpf : state.nuCpf ),
        "nmPessoaFisica": state.data.pessoaFisica.nmPessoaFisica ? state.data.pessoaFisica.nmPessoaFisica : state.nmPessoaFisica,
      });
    }

    setDadosDirigenteExcepcionalFull(state.data);

    // PREVINE SAIDA DA PÁGINA COM DADOS EM EDIÇÃO
    handlerRef.current = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ''; // Still required in most browsers
    };

    if (ctrlDoc.length === 0) getCtrlDocCons();
  }, []);

  useEffect(() => {
    if (manter === 2 && dadosDirigenteExcepcional) { // SE OS DADOS DE DIRIGENTE EXCEPCIONAL JÁ ESTIVEREM PREENCHIDOS EXIBIR DETALHES - ESTA AÇÃO DECORRE NORMALMENTE QUANDO SE CANCELA A EDIÇÃO
      setDadosDirigenteExcepcionalFull(dadosDirigenteExcepcional);
    }

    if (manter === 3) {
      setActiveKey('item-1');
      setIsDirty(true);
    } else setIsDirty(false);

  }, [manter]);

  useEffect(() => {
    // Verifica se existe registro histórico incompleto. Se sim, consulta o registro novamente para atualizar os dados históricos.
    // Verifica o primeiro e o último registro. Em teoria
    if (!registroHistorico && dadosAuditoria && dadosAuditoria.length > 0) {
      let size = dadosAuditoria.length;
      if (size > 0 && (
        (dadosAuditoria[0].dtPos === undefined || dadosAuditoria[0].dtPos === "")
        || (dadosAuditoria[0].eventos === undefined || dadosAuditoria[0].eventos.length === 0)
      )){
        getDirigenteExcepcionalPorId(dadosDirigenteExcepcional?.idDirExcepcional);
      }

    }

  }, [dadosAuditoria]);

  useEffect(() => {
    if (registroHistorico) { // AUDITORIA/HISTÓRICO
      resetForm();
      setManter(9);
      const audObj = JSON.parse(registroHistorico.corpoPre);
      let obj = {
        ...audObj,
        entidade: dadosDirigenteExcepcional?.entidade,
        dirigenteExcepcionalObjeto: obterObjetoDirExcepPorNumero(audObj.csObjeto),
        dirigenteExcepcionalFuncao: obterFuncaoPorNumero(audObj.csFuncao)
      };
      setDadosDirigenteExcepcionalFull(obj);
      setActiveKey('item-1');
      window.scrollTo(0, 0)
      mostrarInfo("Registro Histórico", "Você está agora vendo um registro histórico. Edições não estão disponíveis");

    }
  }, [registroHistorico]);

  const maskCnpjChange = async (isValue: any) => {
    form?.setFieldsValue({
      nuCnpj: maskCnpj(isValue),
    });
  };
  
  const getDirigenteExcepcionalPorId = async (idDirExcepcional?: number) => {
    try {
      setTipLoading("Atualizando registros históricos");
      setLoading(true);

      let lQuery = `dirigenteExcepcional/${idDirExcepcional}`;
      const { data } = await apiCand.get(lQuery);
      setDadosDirigenteExcepcionalFull(data);

    } catch (error) {
      // console.log(error);
      errorMessage("Erro ao atualizar os registros históricos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasText(cnpjReceitaFederal)) {
      cadastroAutomaticoPessoaJuridica();
    }
    setCnpjReceitaFederal(undefined);

  }, [cnpjReceitaFederal])

  // DESABILITA O BOTÃO EDITAR CASO situacaoVigencia === false. EM TEORIA, SIGNIFICA QUE O REGISTRO CHEGOU AO SEU FIM E NÃO PODE MAIS SER ALTERADO.
  function desabilitaBtnEditar(title: string, msg: string) {
    if (isAntesDoTermino(dadosDirigenteExcepcional?.dtFimAtuacao)){
      if (hasPermissao([Papel.DILIC_MASTER, Papel.DIFIS_CGRE]))
        return false;
    }
    return !hasPermissao([Papel.DILIC_MASTER]);
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  function setDadosDirigenteExcepcionalFull(dirigenteExcepcional: IDirigenteExcepcional) {
    form.setFieldsValue({
      "idDirExcepcional": dirigenteExcepcional.idDirExcepcional,
      "matriculaEfpc": dirigenteExcepcional.entidade?.matricula,
      "sigla": dirigenteExcepcional.entidade?.sigla,

      "campoServidorPublico": dirigenteExcepcional.servidorPublico ? "SIM" : "NÃO",
      "matriculaSiape": dirigenteExcepcional.matriculaSiape,
      "nmCargoOrigem": dirigenteExcepcional.nmCargoOrigem,

      "objeto": dirigenteExcepcional.dirigenteExcepcionalObjeto.descricao,
      "csObjeto": dirigenteExcepcional.dirigenteExcepcionalObjeto.valor,
      "funcao": dirigenteExcepcional.dirigenteExcepcionalFuncao.descricao,
      "csFuncao": dirigenteExcepcional.dirigenteExcepcionalFuncao.valor,

      "dtInicioAtuacao": dirigenteExcepcional.dtInicioAtuacao ? dayjs(dirigenteExcepcional.dtInicioAtuacao) : undefined,
      "dtFimAtuacao": dirigenteExcepcional.dtFimAtuacao ? dayjs(dirigenteExcepcional.dtFimAtuacao) : undefined,
    });
    form.setFieldsValue({
        "nuCnpj": maskCnpj(dirigenteExcepcional.pessoaJuridica?.cnpj),
        "razaoSocial": dirigenteExcepcional.pessoaJuridica?.razaoSocial,
    });

    setCsObjeto(dirigenteExcepcional.dirigenteExcepcionalObjeto.valor);
    setMatriculaEfpc(dirigenteExcepcional.entidade.matricula);

    setServidorPublico(dirigenteExcepcional.servidorPublico);

    setDadosDirigenteExcepcional(dirigenteExcepcional); // RECUPERA OS DADOS DIRETO DA BASE. ESTA ARRAY MANTÉM INTACTO OS DADOS RECEBIDOS DA BASE, QUE PODERÃO SER UTILIZADOS PARA RECUPERAR INFORMAÇÕES EM CASO DE CANCELAMENTO DE EDIÇÃO.
    setDirigenteExcepcionalPlanosBeneficio(dirigenteExcepcional.dirigenteExcepcionalPlanosBeneficio);
    setDirigenteExcepcionalDocumentos(dirigenteExcepcional.dirigenteExcepcionalDocumentos);
    setDadosAuditoria(dirigenteExcepcional.auditoria);
  }

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  //  const [desabilitarEditar, setDesabilitarEditar] = useState(false);

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json = {
      idDirExcepcional: form?.getFieldValue("idDirExcepcional"),
      idPessoaFisica: state.data.pessoaFisica.idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      cnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
      dtInicioAtuacao: form?.getFieldValue("dtInicioAtuacao") ? dayjs(form?.getFieldValue("dtInicioAtuacao")).format("YYYY-MM-DD") : "",
      dtFimAtuacao: form?.getFieldValue("dtFimAtuacao") ? dayjs(form?.getFieldValue("dtFimAtuacao")).format("YYYY-MM-DD") : "",
      statusReg: 1,

      servidorPublico: servidorPublico,
      nmCargoOrigem: form?.getFieldValue("nmCargoOrigem")?.toUpperCase(),
      matriculaSiape: form?.getFieldValue("matriculaSiape"),
      csObjeto: csObjeto !== 0 ? csObjeto : form?.getFieldValue("csObjeto"),
      csFuncao: form?.getFieldValue("csFuncao"),
      dirigenteExcepcionalPlanosBeneficio: dirigenteExcepcionalPlanosBeneficio.map((e: IDirigenteExcepcionalPlanoBeneficio) => {
        return {
          ...e
        };
      }),
      dirigenteExcepcionalDocumentos: dirigenteExcepcionalDocumentos.map((e: IDocumentoDirigenteExcepcional) => {
        return {
          ...e
        };
      }),

    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.put(`/dirigenteExcepcional/${form?.getFieldValue("idDirExcepcional")}`, json).then((response) => {
      setLoading(false);
      resetForm();
      successMessage(
        `Dirigente Excepcional ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) atualizado com Sucesso`
      );

      setManter(2) // VOLTA AO ESTADO INICIAL
      let localServidorPublico = response.data.campoServidorPublico ? response.data.campoServidorPublico : form?.getFieldValue("campoServidorPublico");
      setServidorPublico(localServidorPublico);

      getDirigenteExcepcionalPorId(response.data.idDirExcepcional);

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });

  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    setDadosDirigenteExcepcional(undefined);

    form.getFieldsValue();
    form.setFieldsValue({
      matriculaEfpc: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });

    setMatriculaEfpc('');
    setServidorPublico(false);
    setCsObjeto(0);
    setLoading(false);
    window.scrollTo(0, 0)
  };

  // const validarDirigenteExcepcional = () => {
  //   form
  //     .validateFields([
  //       "matriculaEfpc",
  //       "cnpjPessoaJuridica",
  //       "dtInicioAtuacao",
  //       "dtFimAtuacao",
  //       "campoServidorPublico",
  //       "razaoSocial",
  //       "matriculaSiape",
  //       "nmCargoOrigem",
  //     ])
  //     .then(() => {
  //       sendForm();
  //     })
  //     .catch((error) => {
  //       errorMessage("Campo obrigatório não preechido");
  //     });
  //   //  }
  // };

  const handlerServidorPublico = (value: number) => {
    // console.log(value);
    form.setFieldsValue({
      campoServidorPublico: value === 1 ? "SIM" : "NÃO",
      cnpjPessoaJuridica: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined
    });
    setServidorPublico(value === 1 ? true : false);
  };

  const getCtrlDocCons = async () => {
    let lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,manter,dirigente-excepcional,contexto,transacao`;
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDoc(data.content);
  };

  // Retorna CNPJ se cadastrado na base. Se não existir, faz o cadastro básico
  const getCnpJNaBase = async (value: string) => {
    setTipLoading("Buscando informações sobre o CNPJ na base PREVIC ...");
    setLoading(true);
    await getPessoaJuridica(value).then((response) => {
      setLoading(false);
      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          cnpj: response.data.cnpj,
        });
      }
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status === 404) { // NÃO LOCALIZOU O CNPJ NA BASE
          // BUSCA OS DADOS NA RECEITA FEDERAL E FAZ O CADASTRO AUTOMÁTICO DA PESSOA JURÍDICA COM OS DADOS REDUZIDOS
          setCnpjReceitaFederal(value);
        } else if (err.response.status < 500) {
          setErroApi(err.response.data);
          setLoading(false);
        } else {
          errorMessage(msgErro);
          setLoading(false);
        }
      });
  };

  const cadastroAutomaticoPessoaJuridica = async () => {
    setTipLoading("Cadastro automático de pessoa Jurídica ...");

    // console.log(cnpjReceitaFederal);
    if (!cnpjReceitaFederal) return;
    await postPessoaJuridica(cnpjReceitaFederal).then((response) => {
      setLoading(false);

      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          cnpj: response.data.cnpj,
        });
      }

      successMessage(
        `Pessoa Jurídica ${response?.data?.razaoSocial.toUpperCase()} cadastrada com Sucesso de Forma automática.`
      );

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };


  // Executado ao sair do campo nuCnpj
  const handleInputBlur = (nuCnpj: string) => {
    if (isValidCNPJ(nuCnpj)) {
      nuCnpj = nuCnpj.replace(/\D/g, ""); //Remove tudo o que não é dígito
      getCnpJNaBase(nuCnpj);
    }
  };

  // Add/remove event listener based on `isDirty`
  useEffect(() => {
    const handler = handlerRef.current!;
    if (isDirty) {
      window.addEventListener('beforeunload', handler);
    } else {
      window.removeEventListener('beforeunload', handler);
    }

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('beforeunload', handler);
    };
  }, [isDirty]);

  return (
    <>
      {/* <Prompt
        when={manter === 3}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}
      <div>
        <Watermark display={manter === 9 ? "inline" : "none"} />
        
        <Spin spinning={loading} tip={tipLoading}>
          <PageHeader
            className="site-page-header"
            title={
              (() => {
                switch (manter) {
                  case 2:
                    return "Detalhar Dirigente Excepcional"
                  case 3:
                    return "Alterar Dirigente Excepcional"
                  case 9:
                    return "Histórico Dirigente Excepcional"
                  default:
                    return null
                }
              })()}
            style={{
              marginTop: "-18px",
              background: "#2160BD",
              padding: 5,
              paddingLeft: 24,
            }}
          />


          <Card variant="borderless" style={{ width: "100%" }}>

            <Form
              layout='vertical'
              form={form}
              style={{ padding: 24 }}
              // initialValues={{ remember: false }}
              onFinish={sendForm}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
            >

              <Card title={"Dados Pessoais"}>

                <Row>
                  <Col xs={24} xl={8}>
                    <Form.Item label="CPF" name="nuCpf">
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={12}>
                    <Form.Item label="Nome Completo" name="nmPessoaFisica">
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={4} style={{ display: manter !== 9 ? 'inline' : 'none' }}  >
                    <Form.Item style={{ alignItems: 'center' }}
                      label={mostrarDetalhesPessoaFisica ? "Ocultar detalhe Cadastro de Pessoa Física" : "Detalhar Cadastro de Pessoa Física"}
                    >
                      <Button
                        shape='round'
                        onClick={() => {
                          setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                        }}
                        type='primary'
                        icon={<UserOutlined />}
                      />
                    </Form.Item>

                  </Col>

                </Row>

                <Row>

                  <Col xs={24} xl={4}>
                    <Form.Item label="Servidor Público"
                      name="campoServidorPublico"
                      colon={false}
                      rules={[
                        {
                          required: true,
                          message: "A informação sobre servidor público é obrigatória",
                        },
                      ]}
                    >
                      <Select
                        disabled={manter === 2 || manter === 9 ? true : false}
                        showSearch
                        filterOption
                        optionFilterProp='children'
                        // placeholder=''
                        onChange={handlerServidorPublico}
                        options={[
                          { value: 1, label: 'SIM' },
                          { value: 0, label: 'NÃO' },
                        ]}
                      />
                    </Form.Item>
                  </Col>


                  <Col xs={24} xl={5}>
                    <Form.Item
                      label='CNPJ Origem'
                      name='nuCnpj'
                      rules={[
                        {
                          message: 'Insira um CNPJ válido.',
                          validator: (_, value) => {
                            if (value && value.length !== 0) {
                              if (value.length === 18) {
                                if (isValidCNPJ(value)) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject('CNPJ inválido');
                                }
                              } else {
                                return Promise.reject('CNPJ inválido');
                              }
                            } else {
                              return Promise.resolve();
                            }
                          }
                        }
                      ]}
                    >
                      <Input
                        disabled={manter === 2 || manter === 9 ? true : !servidorPublico}
                        value={form.getFieldValue("nuCnpj")}
                        onChange={(e) => maskCnpjChange(e.target.value)}
                        maxLength={18}
                        onBlur={(e) => handleInputBlur(e.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={3}>
                    <Form.Item
                      label=" "
                      labelCol={{ span: 16 }}
                    >
                      <Button
                        disabled={manter === 2 || manter === 9 ? true : !servidorPublico}

                        type="primary">Pesquisar</Button>
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={12}>
                    <Form.Item
                      label='Órgão/Entidade de Origem'
                      name='razaoSocial'>
                      <Input
                        maxLength={100}
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col xs={24} xl={4}>
                    <Form.Item label='Matrícula SIAPE'
                      name='matriculaSiape'
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: 'O campo matrícula é obrigatório para servidor público.',
                    //   },
                    // ]}
                    >
                      <Input
                        placeholder='Matrícula'
                        disabled={manter === 2 || manter === 9 ? true : !servidorPublico}
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={15}>
                    <Form.Item label='Cargo de Origem'
                      name='nmCargoOrigem'
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: 'O campo cargo de origem é obrigatório para servidor público.',
                    //   },
                    // ]}
                    >
                      <Input
                        placeholder='Cargo'
                        disabled={manter === 2 || manter === 9 ? true : !servidorPublico}
                        maxLength={100}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }} >
                <>
                  <PessoaFisicaDadosPessoaisComplementares
                    form={form}
                    idPessoaFisica={state.data.pessoaFisica.idPessoaFisica}
                    mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                  />
                </>
              </Row>

              <Card title={"Dados de Dirigente Excepcional"}>
                <>
                  <DirigenteExcepcionalPerfil
                    form={form}
                    csObjeto={csObjeto}
                    setCsObjeto={setCsObjeto}
                    entidades={entidades}
                    setMatriculaEfpc={setMatriculaEfpc}
                    manter={manter}
                    dadosDirigenteExcepcional={dadosDirigenteExcepcional}
                  />
                </>
              </Card>

              <Tabs activeKey={activeKey} onChange={setActiveKey}>

                <Tabs.TabPane tab="Documentação" key="item-1">
                  <>
                    <DirigenteExcepcionalDocumento
                      form={form}
                      dirigenteExcepcionalDocumentos={dirigenteExcepcionalDocumentos}
                      setDirigenteExcepcionalDocumentos={setDirigenteExcepcionalDocumentos}
                      ctrlDoc={ctrlDoc}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>

                <Tabs.TabPane tab="Planos de Benefícios" key="item-2">
                  <>
                    <DirigenteExcepcionalPlano
                      form={form}
                      dirigenteExcepcionalPlanosBeneficio={dirigenteExcepcionalPlanosBeneficio}
                      setDirigenteExcepcionalPlanosBeneficio={setDirigenteExcepcionalPlanosBeneficio}
                      matriculaEfpc={matriculaEfpc}
                      manter={manter}
                    />
                  </>
                </Tabs.TabPane>


                <Tabs.TabPane disabled={manter !== 2} tab="Histórico" key="item-99" >
                  <>
                    <Auditoria
                      dadosAuditoria={dadosAuditoria}
                      setRegistroHistorico={setRegistroHistorico}
                    />
                  </>
                </Tabs.TabPane>

              </Tabs>

              <div style={{ display: manter === 9 ? 'inline' : 'none' }}>
                <InfoHistorico form={form} registroHistorico={registroHistorico} />
              </div>

              <CadInfoBotoes
                resetForm={resetForm}
                detalhar={false}
                form={form}
                desabilitaBtnEditar={desabilitaBtnEditar}
                permitirExcluir={hasPermissao([Papel.DILIC_MASTER])}
                resetColor={resetColor}
                manter={manter}
                setManter={setManter}
                setLoading={setLoading}
              />

            </Form>
          </Card>
        </Spin>
      </div>
    </>
  );
};

export default Manter;